/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export interface PodInfo {
  id: string;
  running: boolean;
  start: string;
  expiry: string;
  port?: number;
  ip?: string;
  memory?: number;
  totalUptime: number;
}
